import { render, staticRenderFns } from "./jspg.vue?vue&type=template&id=2139aa04&scoped=true&"
import script from "./jspg.vue?vue&type=script&lang=js&"
export * from "./jspg.vue?vue&type=script&lang=js&"
import style0 from "./jspg.vue?vue&type=style&index=0&id=2139aa04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2139aa04",
  null
  
)

export default component.exports